import React, {useState, useEffect} from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ToastDynamic from './Layout/ToastDynamic/ToastDynamic';
import { useAuth0Account } from '../auth0Utils';
import CONSTANTS from '../constants';
import utils from '../utils';

function AlertWrapper({tenant, token}) {

  const { user } = useAuth0Account();
  const [loading, setLoading] = useState(false);
  const [pendingUsers, setPendingUsers] = useState();
  const [showToast, setShowToast] = useState(true);


  const isSA = utils.isAUserManager(tenant?.tenant, user);
  const workspaceId = tenant?.tenant?.fields?.aDGroupID;
  const isAllowedWorkspace = CONSTANTS.PENDING_USERS_WORKSPACES.includes(workspaceId);

      // On page load gets all pending users and sets them in state
      const getPendingUsers = async () => {

        setLoading(true);

        try {
            let response = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/workspace/${workspaceId}/pending-users`, {
                headers: {
                    "Authorization": "Bearer " + token.accessToken
                }
            });


            if(response.ok) {
              let users = await response.json();

              setPendingUsers(users);
            } else {
              setPendingUsers([]);
            }

        } catch (error) {
            setPendingUsers([]);
        }

        setLoading(false);
    };

  useEffect(() => {
    if (!isSA || !isAllowedWorkspace || sessionStorage.getItem('pendingUsersIgnored')) return;
    getPendingUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSA, isAllowedWorkspace]);

  if (!isSA || !isAllowedWorkspace || sessionStorage.getItem('pendingUsersIgnored')) return null;

  const toastContent = (
    <>
      New users are requesting access. <br/>
      <Link to="/settings" className="btn-link toast-ignore-btn">Go to Settings</Link>
      <Button className="btn-link toast-ignore-btn" variant="link" onClick={() => { sessionStorage.setItem('pendingUsersIgnored', 'true'); setShowToast(false); }}>Ignore</Button>
    </>
  );

  return (
    !loading && pendingUsers && pendingUsers.length > 0 ?
      <ToastDynamic
        show={showToast}
        content={toastContent}
        handleCloseToast={() => setShowToast(false)}
        variant='warning'
      />
    : null
  )
}

export default AlertWrapper
